import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyB-6wPxOk8nCFvi1kDLB9Fe9u11ytqljUc",
  authDomain: "tolkx-d99fd.firebaseapp.com",
  databaseURL: "https://tolkx-d99fd-default-rtdb.firebaseio.com",
  projectId: "tolkx-d99fd",
  storageBucket: "tolkx-d99fd.firebasestorage.app",
  messagingSenderId: "31742782148",
  appId: "1:31742782148:web:d69024013a0d73ac307791",
  measurementId: "G-5QW6ZH3ZY0"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export { app };
export default app;

// authReady resuelve cuando Firebase termina de restaurar la sesión guardada.
// setPersistence solo configura el mecanismo — no espera al usuario.
// onAuthStateChanged dispara una vez con el usuario (o null) al iniciar.
export const authReady = setPersistence(auth, browserLocalPersistence)
  .then(() => new Promise<void>((resolve) => {
    const unsub = auth.onAuthStateChanged((user) => {
      console.log('✅ auth ready, current user:', user?.uid ?? 'null');
      unsub(); // solo necesitamos el primer disparo
      resolve();
    });
  }))
  .catch(console.error);